module.exports = __webpack_public_path__ + "media/images/favicon-3a6de768381e995d975100520de304ee946f75a56f4dda6d8f91a220e45205c1.png";